import * as React from "react";

import { ReactComponent as NextIcon } from "../assets/icon/next-arrow.svg";
import { ReactComponent as BackIcon } from "../assets/icon/back-arrow.svg";

export function Carousel({ children }) {
  const carouselContainerRef = React.useRef(null);

  const [carouselContainerWidth, setCarouselContainerWidth] = React.useState(0);
  const [carouselIndex, setCarouselIndex] = React.useState(0);
  const [itemsInView, setItemsInView] = React.useState(1);

  const itemsCount = React.Children.count(children);
  const itemsOffScreen = itemsCount - itemsInView;
  const isLeftOverflow = carouselIndex > 0;
  const isRightOverflow = carouselIndex < itemsOffScreen;

  const observerRef = React.useRef(
    new ResizeObserver((entries) => {
      const elem = entries[0].target;
      const containerWidth = elem.offsetWidth;
      const carouselItemWidth = 500;

      setCarouselContainerWidth(containerWidth);
      setItemsInView(Math.round(containerWidth / carouselItemWidth));
    })
  );

  React.useLayoutEffect(() => {
    if (!carouselContainerRef.current) return;

    const observer = observerRef.current;

    observer.observe(carouselContainerRef.current);

    return () => observer.disconnect();
  }, []);

  const handleNext = () => {
    if (carouselIndex === itemsOffScreen) return;
    setCarouselIndex(carouselIndex + 1);
  };

  const handlePrevious = () => {
    if (carouselIndex === 0) return;
    setCarouselIndex(carouselIndex - 1);
  };

  return (
    <div
      className="relative overflow-hidden flex items-center px-4"
      ref={carouselContainerRef}
    >
      {isLeftOverflow && (
        <button
          className="flex-initial flex-shrink-0 px-3 py-1  text-white absolute left-0 z-30"
          onClick={handlePrevious}
        >
          <BackIcon className="w-24 h-24" />
        </button>
      )}

      <div
        style={{
          transform: `translateX(-${
            (carouselContainerWidth / itemsInView) * carouselIndex
          }px)`,
        }}
        className="flex transition-transform duration-300"
      >
        {React.Children.map(children, (child, index) => {
          return (
            <div
              key={index}
              className="shrink-0 px-3 py-0"
              style={{ width: `${carouselContainerWidth / itemsInView}px` }}
            >
              {child}
            </div>
          );
        })}
      </div>

      {isRightOverflow && (
        <button
          className="flex-initial flex-shrink-0 px-3 py-1  text-white absolute right-0 z-30"
          onClick={handleNext}
        >
          <NextIcon className="w-24 h-24" />
        </button>
      )}
    </div>
  );
}
